import React from "react";
import {Svg, Path} from "react-primitives-svg";
import PropTypes from "prop-types";
import {svgSize} from "../helpers/svg";

export default function Icon({fill, height, width, ...rest}) {
  return (
    <Svg
      {...rest}
      {...svgSize(height, width)}
      viewBox="0 0 35 35"
      preserveAspectRatio="xMidYMid meet">
      <Path
        fill={fill}
        d="M17.8055787,0.807823788 C8.43400674,0.807823788 0.81271969,8.37280797 0.81271969,17.8006828 C0.81271969,27.1730707 8.43400674,34.7380548 17.8055787,34.7380548 C27.1779666,34.7380548 34.7992536,27.1730707 34.7992536,17.8006828 C34.7992536,8.37280797 27.1779666,0.807823788 17.8055787,0.807823788 Z M21.0238181,26.7773186 C21.0238181,28.5839063 20.1205242,29.995558 18.3139365,29.995558 C16.5636516,29.995558 15.6040548,28.5839063 15.6040548,26.7773186 L15.6040548,18.986307 C13.2328064,18.986307 12.4992372,17.8006828 12.4992372,16.6721774 C12.4992372,15.3731315 13.402531,14.3572319 14.9267884,14.3572319 L18.0316061,14.3572319 C19.8381939,14.3572319 21.0238181,15.7688835 21.0238181,17.5754713 L21.0238181,26.7773186 Z M21.475873,8.6551383 C21.475873,10.5743318 19.8944967,11.8733777 17.8055787,11.8733777 C15.7174766,11.8733777 14.1361003,10.5743318 14.1361003,8.6551383 L14.1361003,8.37280797 C14.1361003,6.45361448 15.7174766,5.21168741 17.8055787,5.21168741 C19.8944967,5.21168741 21.475873,6.45361448 21.475873,8.37280797 L21.475873,8.6551383 Z"
        id="Shape"
      />
    </Svg>
  );
}

Icon.propTypes = {
  fill: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Icon.displayName = "Icons.Info";
